/** URL slugs for the Retail space pages and Industrial sector pages (pure data, safe for Node). */
export const RETAIL_VENUE_SLUGS = [
  "gasolineras",
  "hoteles",
  "gimnasios",
  "campus",
  "coworkings",
  "campings",
  "estadios",
] as const;
export type RetailVenueSlug = (typeof RETAIL_VENUE_SLUGS)[number];

export const INDUSTRIAL_SECTOR_SLUGS = [
  "automocion",
  "alimentacion",
  "metalurgia",
  "quimica",
  "papel-packaging",
  "energia",
] as const;
export type IndustrialSectorSlug = (typeof INDUSTRIAL_SECTOR_SLUGS)[number];

/** Spanish labels for llms.txt (generated in Node, no i18n there). */
export const VENUE_LABELS_ES: Record<RetailVenueSlug, string> = {
  gasolineras: "Gasolineras",
  hoteles: "Hoteles",
  gimnasios: "Gimnasios",
  campus: "Campus y universidades",
  coworkings: "Coworkings y oficinas",
  campings: "Campings",
  estadios: "Estadios y recintos",
};

export const SECTOR_LABELS_ES: Record<IndustrialSectorSlug, string> = {
  automocion: "Automoción",
  alimentacion: "Alimentación y bebidas",
  metalurgia: "Metalurgia y fabricación",
  quimica: "Química y procesos",
  "papel-packaging": "Papel y packaging",
  energia: "Energía e infraestructuras",
};
